export default "__VITE_ASSET__50770be2__"